<div class="vertical-buttons">
    <ng-template ngFor let-btn [ngForOf]="btnGroupOptions.items">
        <button title="{{btn.title}}" (click)="btnClick(btn.action)">
            <ui-lightning-icon *ngIf="btn.icon" [iconName]="btn.icon" size="xx-small" alternativeText="{{btn.title}}"></ui-lightning-icon>
            <span *ngIf="btn.label">{{btn.label}}</span>
        </button>
    </ng-template>
</div>